import { useCallback } from 'react';
import { IconButton } from '@cbhq/cds-web/buttons';
import { HStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system/Pressable';
import { TextHeadline } from '@cbhq/cds-web/typography';

import { openUrlInNewWindow } from ':cloud/utils/openUrlInNewWindow';

type LinkButtonProps = { text: string; url: string };

export function LinkButton({ text, url }: LinkButtonProps) {
  const onPress = useCallback(() => openUrlInNewWindow(url), [url]);
  return (
    <Pressable onPress={onPress} background="transparent">
      <HStack alignItems="center" gap={1}>
        <TextHeadline as="h4" color="primary">
          {text}
        </TextHeadline>
        <IconButton name="externalLink" variant="primary" transparent />
      </HStack>
    </Pressable>
  );
}
